import axios from 'axios';
import { ApiResponse } from '../types/planModel';
import { planRequestEndpoint } from '../endpoint';
import { getEnvironmentEndpoint } from '../utils/getEnvironmentEndpoint';

export const fetchAnswerEstimates = async (serviceRequestUuid: string): Promise<ApiResponse> => {
  const endpoint = getEnvironmentEndpoint(planRequestEndpoint);
  const response = await axios.post<ApiResponse>(
    endpoint,
    {
      event: 'getAnswerEstimates',
      payload: {
        serviceRequestUuid,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer retool_wk_2a52f0500dda4c2789165defc8687c4d',
      },
    },
  );

  // return response.data.body.answer_estimates;
  return response.data;
};
